import React from 'react';
import { Form } from 'react-bootstrap';
import { FastField } from 'formik';
import PropTypes from 'prop-types';
import { formLabel } from '../../utils/helpers';

function FormCheck({ name, className }) {
    return (
        <FastField name={name}>
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = meta.touched && !isValid;

                return (
                    <Form.Switch
                        id={name}
                        onChange={() => {
                            form.setFieldValue(field.name, !meta.value);
                        }}
                        checked={meta.value}
                        isInvalid={isInvalid}
                        value={meta.value}
                        label={formLabel(name)}
                        className={className}
                    />
                );
            }}
        </FastField>
    );
}

FormCheck.defaultProps = {
    className: '',
};
FormCheck.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
};
export default FormCheck;
